import 'rxjs/add/operator/finally';
import * as props from './../../api/login';
import { Commons } from './../../utils/commons';
import { Component } from '@angular/core';
import { CustomErrorHandler } from "@questrade/flx-commons";
import { CustomValidators } from "../../utils/validators";
import { DeveloperProvider } from './../../providers/developers';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { GlobalVariables } from "../../variables/global";
import { LoadingProvider } from './../../providers/loading';
import { NavController, IonicPage, Events } from 'ionic-angular';
import { ToastProvider } from './../../providers/toast';

@IonicPage({
  name: 'login'
})
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})

export class LoginPage {
  addUserForm: FormGroup;
  forgotPasswordForm: FormGroup;
  formType: string = 'login';
  loadingInstance = null;
  loginContent;
  loginForm: FormGroup;
  loginProps;
  newAccountForm: FormGroup;
  newUserPasswordForm: FormGroup;
  newAccountProps;
  resetPasswordForm: FormGroup;
  token: string;
  username: string;
  validations_form;

  private initialPage: number = 1;

  constructor(
    public navCtrl: NavController,
    public formBuilder: FormBuilder,
    private devProvider: DeveloperProvider,
    private loading: LoadingProvider,
    private toast: ToastProvider,
    private events: Events,
    private customErrorHandler: CustomErrorHandler) {
    this.buildForm();
    this.events.publish('menu:changed', false);
  }

  buildForm() {
    const urlParams = this.getUrlParams(window.location.search);
    this.loginProps = props;
    const renderFormType = (urlParams['token'] && urlParams['username']) ?
      this.createResetForm(urlParams['username'], urlParams['token']) :
      this.createLoginForm();

    return renderFormType;
  }

  getUrlParams(url) {
    return url.substr(1).split('&').reduce(function (q, query) {
      const chunks = query.split('=');
      const key = chunks[0];
      const value = chunks[1];
      return (q[key] = value, q);
    }, {});
  }

  cbByAccesType(adminCallback, devCallback) {
    if (GlobalVariables.accessType === 'ADMIN' && adminCallback) return adminCallback.bind(this)();
    if (GlobalVariables.accessType === 'DEV' && devCallback) return devCallback.bind(this)();
  }

  createLoginForm() {
    this.loginForm = this.formBuilder.group({
      username: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required)
    });

    this.formType = 'login';
  }

  createForgotPassword() {
    this.forgotPasswordForm = this.formBuilder.group({
      username: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, CustomValidators.emailValidator])
    });

    this.formType = 'forgot-password';
  }

  createResetForm(username, token) {
    this.username = username;
    this.token = token;
    this.resetPasswordForm = this.formBuilder.group({
      password: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required)
    });

    this.formType = 'reset-password';
  }

  createNewAccountForm() {
    this.newAccountForm = this.formBuilder.group({
      first_name: new FormControl('', Validators.required),
      last_name: new FormControl('', Validators.required),
      merchant: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, CustomValidators.emailValidator])
    });
    this.newUserPasswordForm = this.formBuilder.group({
      username: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required)
    });
    this.formType = 'create-account';
  }

  goToHome(res) {
    let data = {};

    this.cbByAccesType(() => {
      data = { users: res.developers, admin: this.loginForm.value.username };
    }, () => {
      data = { userDetail: data }
    });

    return this.navCtrl.setRoot('home', data);
  }

  goToLogin() {
    this.formType = 'login';
  }

  getUserInfo() {
    this.devProvider.getUser(this.loginForm.value.username)
      .subscribe(data => {

        GlobalVariables.authToken = data.auth_token;
        GlobalVariables.role = data.role;

        this.publishLoginEvent();

        return this.goToHome(data);
      }, error => {
        return this.customErrorHandler.handleError(error.json());
      }, () => {
        return this.loadingInstance.dismiss();
      });
  }

  getUsers() {
    this.devProvider.getUsers(this.initialPage)
      .subscribe(data => {
        this.publishLoginEvent();

        return this.goToHome(data);
      }, error => {
        return this.customErrorHandler.handleError(error.json());
      }, () => {
        return this.loadingInstance.dismiss();
      });
  }

  publishLoginEvent() {
    return this.events.publish('user:login');
  }

  submitLogin() {
    const networkError = 'Network error. Please check the internet conection';
    const fieldError = 'Username or Password are incorrect';

    if (!this.loginForm.valid) return;

    this.loadingInstance = this.loading.create();

    this.devProvider.login(this.loginForm.value)
      .subscribe(data => {
        GlobalVariables.accessType = data.access_type;
        GlobalVariables.username = this.loginForm.value.username;

        GlobalVariables.role = '';

        return this.cbByAccesType(this.getUsers, this.getUserInfo);
      }, error => {
        this.loadingInstance.dismiss();
        let errorMessage: string = error['status'] === 409 ? networkError : fieldError;
        this.toast.create(errorMessage, 'error');
      });
  }

  evalPasswordPolicies(password, control: FormGroup, name) {
    const passwordPolicies = JSON.parse(GlobalVariables.passwordPolicies);
    passwordPolicies.securityPolicyRules.forEach(passwordPolicy => {
      const policy = new RegExp(passwordPolicy.regexString);
      const result = policy.test(password);
      if (!result) {
        control.controls[name].setErrors({ invalid: true })
        Commons.markAsInvalid(name);
        return;
      }
    });
  }

  submitResetPassword() {
    if (this.resetPasswordForm.value.password !== this.resetPasswordForm.value.confirmPassword) {
      this.resetPasswordForm.controls['confirmPassword'].setErrors({ invalid: true });
      this.loginProps.formReset.confirmPassword['blur'] = true;
      Commons.markAsInvalid('confirmPassword');
    }
    this.evalPasswordPolicies(this.resetPasswordForm.value.password, this.resetPasswordForm, 'password');

    if (!this.resetPasswordForm.valid) return;


    this.loadingInstance = this.loading.create();

    this.devProvider.resetPassword(this.token, this.username, this.resetPasswordForm.value.password)
      .finally(() => {
        this.loadingInstance.dismiss();
      })
      .subscribe(data => {
        this.createLoginForm();
        this.toast.create('Password has been reset successfully', 'notification');
        window.history.pushState({}, null, '/');
      }, error => {
        let errorMessage: string = JSON.parse(error._body).error ? JSON.parse(error._body).error : JSON.parse(error._body).message;
        this.toast.create(errorMessage, 'error');
      });
  }

  submitForgotPassword() {
    if (!this.forgotPasswordForm.valid) return;

    this.loadingInstance = this.loading.create();

    this.devProvider.forgotPassword(this.forgotPasswordForm.value.username, this.forgotPasswordForm.value.email, this.forgotPasswordForm.value.password)
      .finally(() => {
        this.loadingInstance.dismiss();
      })
      .subscribe(data => {
        this.toast.create(data.message, 'notification');
      }, error => {
        let errorMessage: string = JSON.parse(error._body).error ? JSON.parse(error._body).error : JSON.parse(error._body).message;
        this.toast.create(errorMessage, 'error');
      });
  }

  submitCreateAccount() {
    if (!this.newAccountForm.valid) return;

    this.evalPasswordPolicies(this.newUserPasswordForm.value.password, this.newUserPasswordForm, 'password');
    if (!this.newUserPasswordForm.valid) return;
    this.loadingInstance = this.loading.create();
    this.newAccountForm.value.username = this.newUserPasswordForm.value.username;
    this.newAccountForm.value.password = this.newUserPasswordForm.value.password;
    this.devProvider.permissionRequest(this.newAccountForm.value)
      .finally(() => {
        this.loadingInstance.dismiss();
      })
      .subscribe(data => {
        this.formType = 'success-message';
      }, error => {
        this.toast.create(error.json().error, 'error');
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts